import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { connect } from 'react-redux';
import { SearchOrders } from '@sbt-web/network/types';
import { SelectBox, type SelectOption } from '@sbt-web/ui';
import type { RootState } from '@/reducers/index';
import { updateOrder as updateListingOrder } from '@/reducers/search';
import { ordersFullLabelsMap } from '@/tools/search/values';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import ownClasses from './index.module.scss';
interface StateProps {
  orders: SearchOrders[];
  orderIndex: number;
}
interface DispatchProps {
  updateOrder: (order: SearchOrders) => void;
}
type Props = StateProps & DispatchProps;
const OrderComponent: FC<Props> = props => {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.orders) {
    t0 = props.orders.map(_temp);
    $[0] = props.orders;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const list = t0;
  let t1;
  if ($[2] !== props) {
    t1 = options => {
      getOrCreatePulse()?.queueEvent({
        type: "Click",
        object: {
          type: "UIElement",
          "@id": "sdrn:subito:listing:search:element:filters-button",
          name: "Sorting Filters Button",
          elementType: "Button",
          label: `${options[0]?.value}`
        }
      });
      return props.updateOrder(options[0].value as SearchOrders);
    };
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSelection = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["order-selector", ownClasses["order-selector"]];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.orderIndex) {
    t3 = [props.orderIndex];
    $[5] = props.orderIndex;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleSelection || $[8] !== list || $[9] !== t3) {
    t4 = <SelectBox name="sort" classes={t2} flavor="small" selectedIndices={t3} valueList={list} onSelect={handleSelection} />;
    $[7] = handleSelection;
    $[8] = list;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const OrderSelector = connect<StateProps, DispatchProps, unknown, RootState>((state: RootState) => ({
  orders: state.search.category.orders,
  orderIndex: state.search.orderIndex
}), dispatch => ({
  updateOrder: (order: SearchOrders) => dispatch(updateListingOrder(order))
}))(OrderComponent);
export { OrderComponent };
function _temp(order) {
  return {
    name: ordersFullLabelsMap[order],
    value: order
  };
}